import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import h1 from "../Images/h1.jpg";
import h3 from "../Images/h3.png";
import h4 from "../Images/h4.jpg";
import indsac_multiple_platforms from "../Images/indsac-multiple-platforms.gif";
import indsac_management_processes from "../Images/indsac-management-processes.gif";
import SEO from "../components/SEO";  // 

export default function Healthcare() {
  return (
    <>
      <SEO  // 
        title="AI ERP & CRM for Healthcare Industry | EnteliPro"
        description="EnteliPro delivers AI-powered ERP and CRM software for healthcare providers. Manage patient records, staff, billing, and compliance efficiently with intelligent automation."
        keywords="Healthcare ERP Software, AI CRM for Healthcare, Patient Management Software, Medical Compliance, Staff Scheduling, Healthcare Analytics"
        canonical="https://www.entelipro.com/Healthcare"
        ogImage="https://www.entelipro.com/static/media/h1.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">  {/*  - <a> to <Link> */}
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Health Care Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4 healthcare-tight">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={h1}
                  alt="EnteliPro AI ERP for Healthcare and Medical Services"  // 
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>  
                  AI ERP & CRM for Healthcare Industry
                </h1>
                <p className="para">
                  The goal of all healthcare providers is to deliver care of the
                  highest quality to patients and consumers. Part of delivering
                  high-quality healthcare services establishing reliable
                  relationships with care seekers and maintaining an organized
                  patient information structure that is accessible by everyone
                  involved in the delivery of healthcare services, while
                  complying with medical information, security, and privacy
                  regulations.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      Improving access to patient data effectively improves the
                      quality of care and increases patient satisfaction.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      A healthcare customer relationship management (CRM) system
                      is an invaluable tool to maintain up-to-date information
                      about patients, offer quality support, gather valuable
                      insights, and provide efficient customer management
                      processes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>How Healthcare CRM Improves Patient Care</h3>
              <p className="para">
                A Healthcare CRM helps to meet patients' needs. Like other
                business organizations, healthcare firms too can utilize CRM
                technology to focus on relationship management, while offering
                more tangible benefits.
              </p>
              <br />

              <p className="para">
                A healthcare CRM solution can become a centralized healthcare
                hub data to manage different data streams. This includes
                communications, analytics, and other passive patient
                interactions. This helps healthcare institutes to create an
                actively engaged consumer base involved in a partnership with
                healthcare professionals.
              </p>
              <br />

              <p className="para">
                A CRM can free up you and your staff to focus on the patients'
                treatments, and more strategic projects, which results in
                enhanced customer experience, reducing waiting times, and
                satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4 healthcare-tight">
        <div className="text-center">
          <h3 className="header-name">
            The Benefits of Having a CRM in the Healthcare Industry
          </h3>
        </div>
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="cwp4-text col-xl-6">
                <h4>Reports, Metrics, and Dashboards</h4>
                <p className="para">
                  A CRM stores data on patients in a communications module so
                  that it is readily available to employees throughout the
                  healthcare system to schedule and track patient appointments
                  and interactions. <br />
                  The patient management module of the CRM enables staff to add
                  or update patient records and access the medical histories of
                  patients to provide better care.
                  <br />
                  The reporting module of the CRM can be designed to segment the
                  patient population to analyze and then understand them
                  better.
                </p>
              </div>
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={h3}
                  alt="EnteliPro Healthcare Reports and Analytics Dashboard"  // 
                  className="img-responsive "
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4 healthcare-tight">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={h4}
                  alt="EnteliPro Healthcare Marketing and Patient Communication"  // 
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Mailing and Marketing Campaigns</h4>
                <p className="para">
                  A healthcare CRM can track patient satisfaction and the
                  patients' likelihood of referring others to the healthcare
                  establishment. Such data provides valuable feedback to
                  healthcare executives to make data-driven decisions.
                  <br />
                  The CRM allows you to filter your contacts to get a targeted
                  list of patients or prospective patients who would most likely
                  be interested in upcoming special offers or new services or
                  products.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4 healthcare-tight">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="cwp4-text col-xl-6">
                <h4>Customer Management Processes</h4>
                <p className="para">
                  Filing out forms, reporting, compliance with regulations,
                  appointments, patient notes by doctors and nurses, medications
                  prescribed and on hand, etc. All of these tasks, which involve
                  a specific sequence of actions, can be automated with a CRM.
                  <br />
                  The task management module of the CRM allows staff to add a
                  task, assign it to an individual staff member, and track the
                  progress, deadline, priority, and completion of the job.
                </p>
              </div>
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsac_management_processes}
                  alt="EnteliPro Healthcare Patient Management and Workflow Automation"  //
                  className="img-responsive "
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4 healthcare-tight">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsac_multiple_platforms}
                  alt="EnteliPro Healthcare CRM Accessible on Multiple Platforms"  // 
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Availability on Multiple Platforms</h4>
                <p className="para">
                  CRM software is one of the most popular types of software for
                  business and healthcare practices. Approximately 50% of users
                  access CRM software from a smartphone or a tablet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}